<template>
  <v-card>
    <v-card-title primary-title>
      <div>
        <div class="headline secondary--text">{{ $t('company.consumer.profile.title') }}</div>
        <span class="body-1 greyDarken1--text">{{ $t('company.consumer.profile.subtitle') }}</span>
      </div>
      <v-spacer></v-spacer>
      <v-btn @click="exportReport()" color="secondary">
          <v-icon small class="pr-1">$vuetify.icons.rms_media_download</v-icon>
          {{ $t('company.consumer.details.export') }}
        </v-btn>
    </v-card-title>

    <v-card-text>
      <v-card class="mb-4">
        <v-card-title>
          <h3 class="secondary--text">{{ $t('company.consumer.details.section.title') }}</h3>
          <v-spacer></v-spacer>
          <v-btn
            v-if="userRoleInCompany >= DEFINES.ROLE_ADMIN && !is_editing"
            dark
            class="pa-0 ma-0"
            color="secondary"
            @click="is_editing = !is_editing"
          >
            <v-icon small>$vuetify.icons.rms_edit</v-icon>
            &nbsp;{{ $t('rms.button.edit') }}
          </v-btn>
          <v-btn v-if="is_editing" @click="save()" dark color="secondary" class="pa-0 ma-0">
            <v-icon small>$vuetify.icons.rms_save</v-icon>
            &nbsp;{{ $t('rms.button.save') }}
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <!-- Consumer details-->
        <v-card-text class="px-0" v-if="consumer">
          <v-layout row wrap justify-center align-start>
            <v-flex xs12 md12 lg12>
              <v-form ref="form" onsubmit="return false;">
                <!-- About Consumer -->
                <v-layout row wrap>
                  <v-flex xs12 class="px-3">
                    <v-text-field
                      v-model="consumer.name"
                      :disabled="!is_editing"
                      :label="$t('company.consumer.details.form.input.name')"
                      color="primary"
                      :rules="[
                        rules.required,
                        rules.min_length(3),
                        rules.max_length(250),
                      ]"
                      type="string"
                      name="name"
                      counter="250"
                    ></v-text-field>
                    <v-text-field
                      v-model="consumer.email"
                      :disabled="!is_editing"
                      color="primary"
                      :label="$t('company.consumer.details.form.input.email')"
                      :rules="[
                        rules.required,
                        rules.email
                      ]"
                      name="email"
                      counter="250"
                    ></v-text-field>
                    <v-text-field
                      v-model="consumer.phone"
                      :disabled="!is_editing"
                      color="primary"
                      :label="$t('company.consumer.details.form.input.phone')"
                      type="number"
                      name="phone"
                    ></v-text-field>
                    <v-text-field
                      v-model="password"
                      :disabled="!is_editing"
                      color="primary"
                      :label="$t('company.consumer.details.form.input.password')"
                      type="text"
                      name="password"
                    ></v-text-field>
                    <v-checkbox
                      :label="$t('company.consumer.details.form.input.is_verified')"
                      :disabled="!is_editing"
                      v-model="consumer.is_verified"
                      color="blue"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <v-card class="mb-4">
        <v-card-title>
          <h3 class="secondary--text">{{ $t('company.consumer.participated.screenings.title') }}</h3>
          <v-spacer></v-spacer>
          <v-chip color="secondary" class="white--text" v-if="consumer">{{consumer.participated_screenings.length}}</v-chip>
        </v-card-title>
        <v-divider></v-divider>
        <v-data-table
            v-if="consumer"
          :headers="table_headers"
          :items="consumer.participated_screenings"
        >
          <template v-slot:items="props">
            <tr >
              <td class="text-xs-left">{{ props.index + 1 }}</td>
              <td class="text-xs-left">{{ props.item.id }}</td>
              <td class="text-xs-left">{{ props.item.title }}</td>
              <td class="text-xs-left">
                  <template v-if="isScreeningPaid(props.item) || props.item.pivot.is_paid">
                      <span>{{$t('common.field.yes')}}</span>
                  </template>
                    <template v-else>
                        <span>{{ $t('common.field.no') }}</span>
                    </template>
              </td>
              <td class="text-xs-left">
                  <template v-if="isScreeningPaid(props.item) || props.item.pivot.is_paid">
                        <v-icon v-if="props.item.pivot.is_purchased" color="success"
                        >mdi-check</v-icon
                        >
                        <v-icon v-else color="error">mdi-window-close</v-icon>
                    </template>
                    <template v-else>
                        <span>{{ $t('screener.not_applicable') }}</span>
                    </template>
              </td>
              <td class="text-xs-left">
                   <template v-if="props.item.pivot.is_enrolled">
                      <span>{{$t('common.field.yes')}}</span>
                  </template>
                <template v-else>
                    <span>{{ $t('common.field.no') }}</span>
                </template>
              </td>
              <td class="text-xs-left">
                   <template v-if="props.item.pivot.screening_attended">
                      <span class="success--text" >{{$t('common.field.yes')}}</span>
                  </template>
                <template v-else>
                    <span class="error--text">{{ $t('common.field.no') }}</span>
                </template>
              </td>


            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert
              :value="true"
              color="error"
              icon="warning"
            >{{ $t('rms.alert.search_not_found') }}</v-alert>
          </template>
        </v-data-table>
      </v-card>
    </v-card-text>
  </v-card>
</template>
<script>
import DEFINES from "@/defines";
import { mapFields } from "vuex-map-fields";
import { mapState, mapGetters } from "vuex";
import i18n from "@/i18n";
import Avatar from "vue-avatar";
import rules from "@/validation";
export default {
  name: "ConsumerProfile",
  props: {
    consumer: {
      type: Object,
      default: null
    }
  },
  components: {
    Avatar
  },
  data() {
    return {
      rules,
      is_editing: false,
      password: null,
      table_headers: [
        { text: "SN", align: "left", sortable: false },
        {
          text: i18n.t(
            "company.consumer.participated.screenings.table.header.screener.id"
          ),
          sortable: false,
          align: "left",
          value: "id"
        },
        {
          text: i18n.t(
            "company.consumer.participated.screenings.table.header.title"
          ),
          sortable: true,
          align: "left",
          value: "title"
        },
        {
          text: i18n.t(
            "company.consumer.participated.screenings.table.header.is_paid"
          ),
          sortable: false,
          align: "left",
          value: "is_paid"
        },
        {
          text: i18n.t(
            "company.consumer.participated.screenings.table.header.purchased"
          ),
          sortable: false,
          align: "left",
          value: "purchased"
        },
        {
          text: i18n.t(
            "company.consumer.participated.screenings.table.header.enrolled"
          ),
          align: "left",
          sortable: true,
          value: "enrolled"
        },
        {
          text: i18n.t('company.consumer.participated.screenings.table.header.attended'),
          align: "left",
          value: "delete",
          sortable: true
        }
      ]
    };
  },

  computed: {
    ...mapGetters("company", {
      selected_company_id: "getSelected"
    }),

    ...mapGetters('screener', {
      isScreeningPaid: 'isScreeningPaid',
    }),

    userRoleInCompany() {
      return this.$store.getters["company/userRoleInCompany"](
        this.selected_company_id
      );
    }
  },

  methods: {
    async save() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      this.consumer.password = this.password;
      var response = await this.$store
        .dispatch("consumer/update", this.consumer)
        .then(response => {
          this.is_editing = false;
          this.$store.dispatch("app/showMessage", {
            message: "Updated successfully!",
            color: "success"
          });
        })
        .catch(error => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error"
          });
        });
    },

    async exportReport() {
      this.$store.dispatch('consumer/exportReport',{
        consumer_id: this.$route.params.consumer_id
      })
      .then((response) => {
        window.open(response.link, '_blank');
      })
      .catch((error) => {
        this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error"
        });
      })
    }
  }
};
</script>
